import { BaseProjectCommand } from './base-project-command.model';

export class CreateProjectCommand extends BaseProjectCommand {}
